import { put, retry, takeEvery } from 'redux-saga/effects'
import { ThemeApi } from '../../api/Theme'
import { ThemeResult } from '../../api/Theme/types'
import { isOfflineError } from '../../services/errorManager'
import { BOOT_RETRY_ATTEMPTS, BOOT_RETRY_DELAY } from '../boot'
import { ThemeActions } from './actions'
import { LoadThemeActionTypes } from './types'

function* loadThemeSaga() {
  try {
    const themeConfig: ThemeResult = yield retry(BOOT_RETRY_ATTEMPTS, BOOT_RETRY_DELAY, ThemeApi.load)
    yield put(ThemeActions.storeThemeConfig(themeConfig))
  } catch (error) {
    if (!isOfflineError(error as Error)) {
      console.error('ERROR =', error)
    }
  }
}

export function* loadThemeWatcher() {
  yield takeEvery(LoadThemeActionTypes.LOAD_THEME, loadThemeSaga)
}
